import Router from 'vue-router';

const layout = () => import('@/layouts/Admin');

export const routes = [
  /**
  * GENERAL
  */
  {
    path: '/',
    redirect: '/welcome',
  },
  {
    path: '/welcome',
    name: 'Welcome',
    components: {
      default: () => import('@/views/Admin/Welcome'),
      layout,
    },
    meta: {
      // hideAdminNavbar: true,
    },
  },
  {
    name: 'Error',
    path: '/error',
    component: () => import('@/views/Error'),
  },
  {
    name: 'Error-Status',
    path: '/error/:status',
    component: () => import('@/views/Error'),
    props: true,
  },

  /**
  * AUTH
  */
  {
    name: 'Login',
    path: '/login',
    component: () => import('@/views/Admin/Auth'),
    meta: {
      hideAdminNavbar: true,
    },
  },
  {
    name: 'LoginConfirm',
    path: '/login/confirm',
    component: () => import('@/views/Admin/Auth'),
    meta: {
      hideAdminNavbar: true,
    },
  },
  {
    name: 'Logout',
    path: '/logout',
    component: () => import('@/views/Admin/Auth'),
    meta: {
      hideAdminNavbar: true,
    },
  },
  {
    name: 'LogoutConfirm',
    path: '/logout/confirm',
    component: () => import('@/views/Admin/Auth'),
    meta: {
      hideAdminNavbar: true,
    },
  },
  {
    name: 'Register',
    path: '/register*',
    component: () => import('@/views/Error'),
    props: {
      err: {
        name: 'NotImplementedError',
        message: 'You cannot register for the Admin panel',
      },
    },
    meta: {
      hideAdminNavbar: true,
    },
  },

  {
    path: '/:companyID',
    redirect: ({ params: { companyID } }) => ({
      name: 'CompanyDashboard',
      params: { companyID }
    }),
  },

  {
    name: 'CompanyLogin',
    path: '/:companyID/login',
    components: {
      default: () => import('@/views/Admin/AuthCompany'),
      layout,
    },
    props: { default: true, layout: false },
  },
  {
    name: 'CompanyLogout',
    path: '/:companyID/logout',
    components: {
      default: () => import('@/views/Admin/AuthCompany'),
      layout,
    },
    props: { default: true, layout: false },
    meta: { requiresAuth: true },
  },
  {
    name: 'CompanySignin',
    path: '/:companyID/sign-in',
    components: {
      default: () => import('@/views/Admin/AuthCompany'),
      layout,
    },
    props: { default: true, layout: false },
    meta: { requiresAuth: true },
  },

  {
    name: 'CompanyDashboard',
    path: '/:companyID/dashboard',
    components: {
      default: () => import('@/views/Dashboards/Controller'),
      layout,
    },
    props: { default: true, layout: false },
    meta: { requiresAuth: true },
  },
  // {
  //   name: 'GraphQLPlayground',
  //   path: '/:companyID/playground',
  //   ...(process.env.VUE_ENV === 'client' ? {
  //     beforeEnter: ({ params: { companyID } }) => window.location.href = `/${companyID}/playground`,
  //   } : {}),
  // },

  {
    path: '/:companyID/jobs/taxonomy',
    name: 'JobIndexTaxonomy',
    props: { default: true, layout: false },
    components: {
      default: () => import('@/views/Admin/JobTaxonomyTool'),
      layout,
    },
    meta: { requiresAuth: true },
  },
  {
    path: '/:companyID/jobs/:jobID/taxonomy',
    name: 'JobShowTaxonomy',
    props: { default: true, layout: false },
    components: {
      default: () => import('@/views/Admin/JobTaxonomyTool'),
      layout,
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/:companyID/jobs/:jobID',
    name: 'JobShow',
    props: { default: true, layout: false },
    components: {
      default: () => import('@/views/jobs/jobShow'),
      layout,
    },
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: '/:companyID/rewards',
    name: 'RewardsIndex',
    components: {
      default: () => import('@/views/User/Rewards'),
      layout,
    },
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: '/:companyID/stats',
    redirect(to) {
      const { companyID } = to.params;
      return { name: 'ManageAnalytics', params: { companyID } };
    },
  },
  {
    name: 'ManageAnalytics',
    path: '/:companyID/manage/analytics',
    components: {
      default: () => import('@/views/Recruiter/Stats'),
      layout,
    },
    props: { default: true, layout: false },
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'ManageAnalyticsReports',
    path: '/:companyID/manage/analytics/queries',
    components: {
      default: () => import('@/views/Recruiter/StatsReports'),
      layout,
    },
    props: { default: true, layout: false },
    meta: {
      requiresAuth: true,
    },
  },

  {
    name: 'ManageAll',
    path: '/:companyID/manage',
    components: {
      default: () => import(/* webpackChunkName: "manage" */'@/views/manage/all'),
      layout,
    },
    meta: {
      requiresAuth: true,
      requiresRecruiter: true,
    },
  },
  ...(process.env.NODE_ENV === 'production' ? [] : [
    {
      name: 'ManageEntryInputs',
      path: '/:companyID/manage/inputs',
      components: {
        default: () => import(/* webpackChunkName: "manage" */'@/views/manage/inputs'),
        layout,
      },
      meta: {
        requiresAuth: true,
        requiresRecruiter: true,
      },
    },
  ]),
  {
    name: 'ManageEntryList',
    path: '/:companyID/manage/:entryType',
    components: {
      default: () => import(/* webpackChunkName: "manage" */'@/views/manage/list'),
      layout,
    },
    props: { default: true, layout: false },
    meta: {
      requiresAuth: true,
      requiresRecruiter: true,
    },
  },
  {
    name: 'ManageEntryView',
    path: '/:companyID/manage/:entryType/:entryID',
    components: {
      default: () => import(/* webpackChunkName: "manage" */'@/views/manage/view'),
      layout,
    },
    props: { default: true, layout: false },
    meta: {
      requiresAuth: true,
      requiresRecruiter: true,
    },
  },

  {
    path: '*',
    component: () => import('@/views/Error'),
    props: { status: 404 },
  }

];

export function createRouter() {
  return new Router({
    // base,
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      } else if (to.hash) {
        return {
          selector: to.hash
          // , offset: { x: 0, y: 10 }
        };
      } else {
        return { x: 0, y: 0 };
      }
    },
    routes,
  });
}



// WEBPACK FOOTER //
// ./src/router/admin.js